import React, { memo, useEffect, useState } from 'react'
import { edit_item_with_id, getData } from '../../assets/scripts/GeneralFunctions'
import {
  active_bg,
  inactive_bg,
  active_circle_bg,
  inactive_circle_bg,
  inActiveData,
} from '../../functions/stateList'
import EmptyTableContent from '../error/EmptyTableContent'
import TableSkeleton from '../skeleton/tableSkeleton'

function ProductsTable({ searchValue, products }) {
  const [productList, setProductList] = useState([])
  const [ActiveId, setActiveId] = useState(null)

  useEffect(() => {
    setProductList(products)
  }, [products])

  const activeHandler = async (id) => {
    setActiveId(id)
    let apiResult = await getData(
      `admin/site-options/products/change-status/${id}`,
      'get',
      {},
      true
    )
    if (apiResult) {
      if (apiResult?.status === 200) {
        setProductList(edit_item_with_id(productList, apiResult?.data?.product))
      }
      setActiveId(null)
    }
  }

  return (
    <div className="relative rounded-2xl border border-light-gray dark:border-gray-700 max-h-[450px] overflow-auto scroll-smooth bg-table-thead">
      {productList?.length > 0 &&
      productList?.filter(({ name }) => name?.toLowerCase().includes(searchValue?.toLowerCase()))
        ?.length > 0 ? (
        <table className="w-full text-sm text-right relative bg-table-thead dark:bg-slate-800">
          <thead className="text-md bg-table-thead dark:bg-slate-800 sticky top-0 w-full z-10">
            <tr className={'border-b border-b-light-gray dark:border-b-gray-700'}>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                ردیف
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                نام محصول
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                دسته بندی محصول
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                عملیات
              </th>
            </tr>
          </thead>

          <tbody className={'text-md bg-light-blue dark:bg-slate-800'}>
            {productList
              .filter(({ name }) => name?.toLowerCase().includes(searchValue?.toLowerCase()))
              .map((product, index) => {
                return !product || ActiveId === product?.id ? (
                  <TableSkeleton index={index} count={4} key={index} />
                ) : (
                  <tr
                    key={product.id}
                    className="border-b border-b-light-gray dark:border-b-gray-700"
                  >
                    <td className={product?.status ? 'px-6 py-4 dark:text-amber-50' : inActiveData}>
                      {index + 1}
                    </td>
                    <td className={product?.status ? 'px-6 py-4 dark:text-amber-50' : inActiveData}>
                      {product?.name}
                    </td>
                    <td className={product?.status ? 'px-6 py-4 dark:text-amber-50' : inActiveData}>
                      {product?.product}
                    </td>
                    <td className="px-6 py-4 dark:text-amber-50">
                      <div
                        className={product?.status ? active_bg : inactive_bg}
                        onClick={() => activeHandler(product?.id)}
                      >
                        <div
                          className={product?.status ? active_circle_bg : inactive_circle_bg}
                        ></div>
                      </div>
                    </td>
                  </tr>
                )
              })}
          </tbody>
        </table>
      ) : (
        <EmptyTableContent text={'محصولی ثبت نشده است.'} />
      )}
    </div>
  )
}

export default memo(ProductsTable)
